module.exports = __webpack_public_path__ + "static/media/feather.5fad700a.eot";